import FullScreenCard from '../../shared/FullScreenCard';
import GeneralContext from '../../../context/GeneralContext';
import { useContext, useEffect, useState } from 'react';
import { fetchGet, fetchBody } from '../../../utils/fetch';
import Table from '../../shared/Table';

function AdjustPoints() {

    const { changeModalTitle, changeModalType, changeModalText, changeModalContent, changeModalFunction1, changeCurrentMenu } = useContext(GeneralContext);

    const [headers, setHeaders] = useState([
        {id: 'header0', text: 'Alerta'}
    ]);

    const [activeUsersList, setActiveUsersList] = useState([
        {id: '1a', fields: [
            {id: '0', text: 'Error conectándose al servidor'}
          ]
        }
    ]);

    const [tableType, setTableType] = useState('display');

    const prepareUserList = (list) => {
        setHeaders([
            {id: 'header0', text: 'Nombre'},
            {id: 'header1', text: 'Documento'},
            {id: 'header2', text: 'Rol'},
            {id: 'header3', text: 'Puntos'}
        ]);
        const newList = [];
        for (let i = 0; i < list.length; i++) {
            if (list[i].status === 'active') {
                let role = '';
                if (list[i].role === 'user') {role = 'Usuario'};
                if (list[i].role === 'admin') {role = 'Administrador'};
                if (list[i].role === 'super_admin') {role = 'Súper Administrador'};
                const item = {
                    id: list[i].id,
                    fields: [
                        {id: '0', text: list[i].last_name + ' ' + list[i].first_name},
                        {id: '1', text: list[i].document},
                        {id: '2', text: role},
                        {id: '3', text: list[i].points}
                    ]
                }
                newList.push(item);
            }
        }
        setActiveUsersList(newList);
        setTableType('actions');
    }

    useEffect(() => {
        const getUsersList = async () => {
            const response = await fetchGet('');
            if (response.success) {
                prepareUserList(response.list);
            }
        }
        getUsersList();
    }, []);


    const adjustUserPoints = (id, item) => {
        const modal = document.getElementById("myModal");
        changeModalFunction1(() => async () => {
            const fetchData = {
                id: id,
                change: Number(document.getElementById('adjustAmount').value),
                reason: document.getElementById('adjustText').value,
                type: 'adjust'
            }
            let validFetch = true;
            if (fetchData.change === 0) {
                validFetch = false;
                alert('El cambio debe ser diferente de cero');
            }
            if (fetchData.reason.length < 6 && validFetch) {
                validFetch = false;
                alert('Por favor escriba una razón de más de 5 caracteres');
            }
            if (validFetch) {
                const response = await fetchBody('points/', 'POST', fetchData);
                if (response.success) {
                    changeCurrentMenu('manage-points');
                    modal.style.display = "none";
                    document.getElementById('adjustAmount').value = 0;
                    document.getElementById('adjustText').value = '';
                } else {
                    changeModalTitle('Error al intentar cambiar los puntos del usuario');
                    changeModalText(response.reason);
                    changeModalType('alert');
                    modal.style.display = "block";
                }
            }
        })
        changeModalTitle('Ajuste de puntos');
        changeModalText('Ajustando puntos de ' + item[0].text);
        changeModalContent('Puntos actuales: ' + item[3].text);
        changeModalType('adjust');
        modal.style.display = "block";
    }

    const adjustUserActions = [{
        id: 0,
        text: 'Ajustar',
        buttonFunction: adjustUserPoints
    }]

  return (
    <FullScreenCard hasBackNavigation={true} backNavigationFunction={changeCurrentMenu} backNavigationTarget={'manage-points'}>
        <h1>Ajustar Puntos de Usuarios</h1>
        <Table
            headers={headers}
            data={activeUsersList}
            type={tableType}
            actions={adjustUserActions}
        />
    </FullScreenCard>
  )
}

export default AdjustPoints